import { ASSET_MODELS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/asset_models_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'ASSET_MODELS_FOR_TYPES',
	'ASSET_MODELS_AUTOCOMPLETE',
	'bulkEditAssetsAssetModels',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
